/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { cellAggregateRating } from '../model/aggregate';

export function describeCoverage(value: number | string): string {
    const numberValue = typeof value === 'number' ? value : parseInt(value, 10);
    switch (Math.round(numberValue)) {
        case 4:
            return 'Excellent Coverage';
        case 3:
            return 'Good Coverage';
        case 2:
            return 'Some Coverage';
        case 1:
            return 'Major Issues';
        case 0:
            return 'No Service';
        default:
            return '';
    }
}

export function describeCoverageLong(value: number | string): string {
    const numberValue = typeof value === 'number' ? value : parseInt(value, 10);
    switch (Math.round(numberValue)) {
        case 4:
            return 'Clear voice connection; data service sufficient for media streaming (where applicable); no drop-outs within the site/facility. The level of service expected in a major city. Normal social media photo/video upload speeds.';
        case 3:
            return 'Uninterrupted voice connection; consistent but possibly weak/slow data service; rare and/or very small drop-outs at site/facility. Signal may not show as full-strength across site/facility. Slower social media photo/video upload speeds.';
        case 2:
            return 'Phone calls may occasionally drop; text messages may be delayed. Data service may be unusable. Drop-outs are common and it may be necessary to search for signal. Social media likely unusable.';
        case 1:
            return 'Phone calls drop frequently; text messages delayed. No data, or mostly unusable data. Signal may be limited to small areas of site/facility. No social media.';
        case 0:
            return 'Unable to get a signal. Can not make phone calls; No data.';
        default:
            return '';
    }
}

export function calculateAverageCellSignal(
    cellRatings: Array<cellAggregateRating>
): number {
    const { ratingTotal: ratingSum, numRatings: totalRatings } = cellRatings.reduce(
        ({ ratingTotal, numRatings }, { average_rating, number_of_ratings }) => ({
            ratingTotal: ratingTotal + average_rating * number_of_ratings,
            numRatings: numRatings + number_of_ratings,
        }),
        { ratingTotal: 0, numRatings: 0 }
    );

    return ratingSum / totalRatings;
}
